import { RouterProvider } from "react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { customQueryFn } from "./api";
import router from "@/routes/index.jsx";
import "./i18n/i18n";

const App = () => {
  const { t } = useTranslation();
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        // @ts-expect-error eda
        queryFn: customQueryFn,
      },
    },
  });

  return (
    <div>
      <title>{t("metadata.title")}</title>
      <meta name="description" content={t("metadata.description")} />
      <meta
        name="keywords"
        content="token13, token13.net, token-13.com, bitcoin, blockchain, token13 software llc, token13 dubai, cryptocurrency, bitcoin solutions, blockchain technology"
      />
      <meta property="og:title" content={t("metadata.title")} />
      <meta property="og:description" content={t("metadata.description")} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content="/favicon.svg" />
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </div>
  );
};

export default App;
